import { type DefaultContext, mutationPromise } from '@egw/clients'
import { createMutationHook, createQueryHook } from '../../../hooks'
import {
  type EnrollmentAbandonApplicationSubmitInput,
  type EnrollmentAbandonApplicationSubmitOutput,
} from '../../../models/enrollment/generic/abandon-application'

/**
 * Submit Enrollment  AbandonApplication data
 * @param context - reference to the AbortController used to abort the call (optional)
 * @returns Promise<EnrollmentAbandonApplicationSubmitOutput>
 * @example const response = await submitEnrollmentAbandonApplicationData();
 */
export const submitEnrollmentAbandonApplicationData = async (
  enrollmentAbandonApplicationSubmitInput: EnrollmentAbandonApplicationSubmitInput,
  context?: DefaultContext,
): Promise<EnrollmentAbandonApplicationSubmitOutput> => {
  const response = (await mutationPromise(
    {
      name: 'submitEnrollmentAbandonApplicationData',
      query: `mutation submitEnrollmentAbandonApplicationData($submitEnrollmentInput: SubmitEnrollmentInput!) {
        submitEnrollment(submitEnrollmentInput: $submitEnrollmentInput) {
          ... on SubmitEnrollmentSuccess {
            __typename
            path
          }
          ... on SubmitEnrollmentError {
            __typename
            path
          }
        }
      }`,
    },
    {
      submitEnrollmentInput: enrollmentAbandonApplicationSubmitInput,
    },
    context,
  )) as { submitEnrollment: EnrollmentAbandonApplicationSubmitOutput }
  return response.submitEnrollment
}

export const useSubmitEnrollmentAbandonApplicationData = createMutationHook<
  EnrollmentAbandonApplicationSubmitInput,
  EnrollmentAbandonApplicationSubmitOutput
>(submitEnrollmentAbandonApplicationData)
